<template>
  <div style="background: white; border-radius: 5px;" v-loading="loading">
    <div class="d-flex justify-content-between align-items-center" >
      <div>
        <h4 style="margin-bottom: 0; padding: 15px 20px">Quản lý tác vụ</h4>
      </div>
      <div>
        <b-button  variant="success" size="md" class="mr-4"
                   v-if="query.createdAt"
                  :disabled="loading_export" :class="{'spinner spinner-white spinner-right' : loading_export}"
                   @click="exportExcelAiWriting"
        >Export chấm AI writing</b-button>
      </div>

    </div>

    <hr style="padding: 0; margin: 0"/>
    <div style="padding:15px 20px">
      <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0">
        <div class="grid-filter">
          <div class="display-flex-column">
            <span>Mã tác vụ</span>
            <el-input v-model="query.taskId" @change="handleSearch" placeholder="Nhập mã tác vụ"/>
          </div>
          <div class="display-flex-column">
            <span>Loại tác vụ</span>
            <el-select v-model="query.typeTask" filterable clearable placeholder="Chọn loại tác vụ" @change="handleSearch">
              <el-option
                  v-for="item in typeTaskOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Loại thi</span>
            <el-select v-model="query.examType" filterable clearable placeholder="Chọn loại thi" @change="handleSearch">
              <el-option
                  v-for="item in ExamType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Hình thức chấm</span>
            <el-select v-model="query.gradingCategory" filterable clearable placeholder="Chọn hình thức chấm" @change="handleSearch">
              <el-option
                  v-for="item in gradingTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Đối tượng xử lý</span>
            <el-input v-model="query.processing" clearable placeholder="Nhập tên, số điện thoại"
                      style="width: 100%" @change="handleSearch"
            />
          </div>
          <div class="display-flex-column">
            <span>Trạng thái</span>
            <el-select v-model="query.status" filterable clearable multiple placeholder="Chọn trạng thái" @change="handleSearch" collapse-tags>
              <el-option
                  v-for="item in statusTaskOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Khóa học</span>
            <el-select v-model="query.course" filterable clearable multiple collapse-tags placeholder="Chọn khóa học" @change="handleSearch">
              <el-option
                  style="max-width: 250px !important;"
                  v-for="item in courses"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Lớp học</span>
            <el-select v-model="query.classroom" filterable clearable multiple collapse-tags placeholder="Chọn lớp học" @change="handleSearch">
              <el-option
                  style="max-width: 250px !important;"
                  v-for="item in classrooms"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Thời gian bắt đầu</span>
            <el-date-picker
                v-model="query.createdAt"
                clearable
                end-placeholder="Đến ngày"
                format="dd/MM/yyyy"
                start-placeholder="Từ ngày"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
            />
          </div>
          <div class="display-flex-column">
            <span>Người phụ trách</span>
            <el-select v-model="query.personInCharge" filterable clearable placeholder="Chọn người phụ trách" @change="handleSearch">
              <el-option
                  v-for="item in adminList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Phân loại chấm</span>
            <el-select v-model="query.gradingType" clearable placeholder="Chọn phân loại chấm" @change="handleSearch">
              <el-option
                  v-for="item in gradingCategoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="display-flex-column">
            <span>Thời hạn chấm bài</span>
            <el-date-picker
                v-model="query.deadline"
                clearable
                end-placeholder="Đến ngày"
                format="dd/MM/yyyy"
                start-placeholder="Từ ngày"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
            />
          </div>
        </div>
      </div>
      <div style="margin: 20px 0; display: flex; align-items: center; gap: 20px" v-if="taskSelectedList.length && (currentUser.user.permission.includes(permission.DIEU_PHOI_TAC_VU_COI_THI))">
        <span>Đã chọn ({{ taskSelectedList.length }})</span>
        <el-button type="success" style="background: #500DA7; color: white; border: 0"
                   @click="isAddPersonInCharge = true">
          <i class="el-icon-plus" style="color: white"></i> Phân công chấm
        </el-button>
        <el-button type="info" style="background: #E6E6E6; border: 0; display: flex; align-items: center"
                   @click="cancelSelected">
          <i class="el-icon-close" style="color: black"></i> Hủy
        </el-button>
      </div>
      <div class="example-preview mt-8" style="height: 515px; overflow: auto">
        <table class="table table-vertical-center table-bordered" style="min-height: 100px">
          <thead style="position:sticky; top: 0">
          <tr style="background-color: #F8F8F8;">
            <th scope="col" class="w-[40px]" style="background: #F8F8F8">
              <el-checkbox v-model="isSelectedAll" @change="selectedAllTask"></el-checkbox>
            </th>
            <th scope="col" class="w-[90px]" style="background: #F8F8F8; text-align: start">Mã tác vụ</th>
            <th scope="col" class="min-w-[180px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Tác vụ</th>
            <th scope="col" class="min-w-[180px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Loại thi</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Đối tượng xử lý</th>
            <th scope="col" class="min-w-[40px]" style="background: #F8F8F8; text-align: start;">Trạng thái</th>
            <th scope="col" class="min-w-[40px]" style="background: #F8F8F8; text-align: start;">Khóa học</th>
            <th scope="col" class="min-w-[40px]" style="background: #F8F8F8; text-align: start;">Lớp học</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start">Người phụ trách</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start">Thời gian tạo</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start">Thời gian assign tác vụ</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start">Thời hạn chấm bài</th>
            <th scope="col" class="w-[100px] text-center" style="background: #F8F8F8;">Hành động</th>
          </tr>
          </thead>
          <tbody v-if="manageTaskList?.length > 0">
          <tr v-for="item of manageTaskList" :key="item?.id" style="border: 1px solid #EBEDF3; border-top: 0">
            <td>
              <el-checkbox v-model="item.selected" @change="getTaskSelectedList"></el-checkbox>
            </td>
            <td>{{ item?.id }}</td>
            <td style="text-align: start">
              <span :class="item.bgType" style="word-break: break-word; padding: 4px 8px; border-radius: 4px; white-space: nowrap">{{ item?.typeTask }}</span>
            </td>
            <td>{{ item?.examTypelabel}}</td>
            <td style="text-align: start">{{ item?.processing }}</td>
            <td style="text-align: start">
              <span :class="item.bgStatus" style="word-break: break-word; padding: 4px 8px; border-radius: 4px; white-space: nowrap"> {{ item?.status }} </span>
            </td>
            <td style="text-align: start">{{ item?.course }}</td>
            <td style="text-align: start">{{ item?.classroom }}</td>
            <td style="text-align: start">{{ item?.gradingHander??item?.handler }}</td>
            <td style="text-align: start">{{ item?.createdAt }}</td>
            <td style="text-align: start">{{ item?.assignedAt }}</td>
            <td style="text-align: start">{{ item?.deadline }}</td>
            <td class="text-center">
              <button class="btn btn-icon btn-xs btn-outline-warning ml-2" title="Cập nhật" @click="handleUpdateTaskDetail(item)">
                <i class="el-icon-edit"></i>
              </button>
              <button class="btn btn-icon btn-xs btn-outline-primary ml-2" @click="handleViewTaskDetail(item)" title="Xem">
                <i class="el-icon-view"></i>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr style="word-break: break-word; white-space: nowrap; position: relative; border: 1px solid #EBEDF3">
            <label style="position: absolute; left: 50%; translate: -50%; top: 10px">Không có dữ liệu</label>
          </tr>
          </tbody>
        </table>
        <div v-if="manageTaskList?.length > 0">
          <div class="edu-paginate mx-auto text-center mt-10 mb-5"
               style="display: flex; justify-content: center; align-items: center; height: 50px">
            <paginate
                v-model="page"
                :page-count="lastPage"
                :page-range="3"
                :margin-pages="1"
                :click-handler="changePage"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
          </div>
          <div class="w-100" style="display: flex;justify-content: flex-end; margin-top: -50px">
            <div>
              Tổng số bản ghi: <span
                style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{
                this.total ?? manageTaskList.length
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="Phân công tác vụ" :show-close="false"
        :visible.sync="isAddPersonInCharge"
        v-if="isAddPersonInCharge" width="30%"
    >
      <hr style="padding: 0; margin-top: -20px"/>
      <DialogTaskAssignment
          @closeDialog="isAddPersonInCharge = false"
          :task-list="taskSelectedList"
          @getManageTaskList="getManageTaskList"
      />
    </el-dialog>
    <el-dialog title="Sửa tác vụ" :show-close="false" :visible.sync="isEdit" v-if="isEdit" width="40%">
      <hr style="padding: 0; margin-top: -20px"/>
      <DialogUpdateTaskDetail :type-task="recordSelected.type" @closeDialog="closeDialogUpdate" :task-id="recordSelected.id"/>
    </el-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {GET_ALL_ADMIN_TEST, GET_MANAGE_TASK_LIST, GET_GRADING_TYPES} from "@/core/services/store/examSchedule/examSchedule";
import {EXPORT_EXCEL_AI_WRITING} from "@/core/services/store/export/export.module";
import {statusTaskOption, typeExams, typeTaskOption} from "@/common/define";
import { mapGetters } from "vuex";
import { TaskModel } from "@/view/pages/manage-exam-schedule/model/TaskModel";
import DialogTaskAssignment from "@/view/pages/manage-exam-schedule/component/DialogTaskAssignment.vue";
import DialogUpdateTaskDetail from "@/view/pages/manage-exam-schedule/component/DialogUpdateTaskDetail.vue";
import {GET_ALL_CLASS} from "@/core/services/store/course/classes.module";
import {GET_COURSES} from "@/core/services/store/course/course.module";
import {Cambridge_Mentor_ID, ECOACH_ID, EDUTALK_ID, IELTS_MENTOR_ID, KEYPASS_ID} from "@/core/option/typeCenterBill";
import {ExamType} from "../../../common/define";

export default {
  name: "ManageTaskList",
  components: {DialogUpdateTaskDetail, DialogTaskAssignment},
  data() {
    return {
      isSelectedAll: false,
      disableSelectedAll: false,
      isEdit: false,
      loading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      manageTaskList: [],
      taskSelectedList: [],
      centers: [],
      recordSelected: {},
      typeExams,
      loadingDelete: false,
      isAddPersonInCharge: false,
      loading_export: false,
      classrooms: [],
      gradingTypes: [],
      adminList: [],
      courses: [],
      query: {
        taskId: null,
        typeTask: null,
        processing: null,
        status: [],
        course: [],
        classroom: [],
        createdAt: [],
        personInCharge: null,
        examType: null,
        gradingType: null,
        gradingCategory: null,
        deadline: null,
      },
      gradingCategoryOptions: [
        { value: 'ai', label: 'Hệ thống' },
        { value: 'admin_ai', label: 'Hệ thống và Admin' },
        { value: 'admin', label: 'Admin' }
      ],
      typeTaskOption,
      statusTaskOption,
      midTermType: 6,
      ExamType
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý tác vụ", name: 'ManageTaskList'},
      {title: "Coi thi - Chấm thi"}
    ]);
    await this.getClassrooms()
    await this.getCourses()
    await this.getAdminList()
    await this.getGradingTypes()
    await this.getManageTaskList()
  },
  methods: {
    selectedAllTask() {
      if (this.isSelectedAll) {
        this.manageTaskList.filter(item => !item.selected).forEach(item => item.selected = true);
        this.taskSelectedList = this.manageTaskList.filter(item => item.selected)
      } else {
        this.manageTaskList.filter(item => item.selected).forEach(item => item.selected = false);
        this.taskSelectedList = []
      }
    },
    cancelSelected() {
      this.manageTaskList.filter(item => item.selected)
      this.manageTaskList = this.manageTaskList.map(task => {
        return {...task, selected: false};
      })
      this.manageTaskList.filter(item => item.selected).forEach((item) => item.selected = false);
      this.taskSelectedList = []
      this.isSelectedAll = false;
    },
    handleViewTaskDetail(item) {
      this.$router.push({
        name: 'TaskManageDetail',
        params: { taskId: item.id },
        query: {
          marking_exam_retake_id: item.markingExamRetakeId,
          is_midTerm: item.examTypelabel === 'Thi giữa khóa',
          classroom_id: item.classroomId
        }
      })
    },
    closeDialogUpdate() {
      this.isEdit = false
      this.getManageTaskList()
    },
    getAdminList() {
      this.isBusy = true
      this.$store.dispatch(GET_ALL_ADMIN_TEST, {type_id: 0}).then(res => {
        if (!res.error) {
          this.adminList = res.data.map((item) => {
            return {
              id: item.id,
              name: item.user_name,
            }
          })
          this.isBusy = false
        }
      })
    },
    getGradingTypes() {
      this.$store.dispatch(GET_GRADING_TYPES).then(res => {
        if (!res.error) {
          this.gradingTypes = res.data ?? []
        }
      })
    },
    handleUpdateTaskDetail(item) {
      this.isEdit = true
      this.recordSelected = item
    },
    workCoordinationSuccess() {
      this.taskSelectedList = []
      this.isSelectedAll = false
    },
    changePage(obj) {
      this.page = obj;
      this.getManageTaskList()
    },
    getCourses() {
      this.$store.dispatch(GET_COURSES, {per_page: 1000000, is_edutalk: 1}).then(res => {
        if (!res.error) {
          this.courses = res.data.data ?? []
        }
      })
    },
    getClassrooms() {
      const payload = {
        center_ids: [EDUTALK_ID, KEYPASS_ID, IELTS_MENTOR_ID, ECOACH_ID, Cambridge_Mentor_ID],
        limit: 1000000,
        status: 1,
        is_edutalk: 1
      }
      this.$store.dispatch(GET_ALL_CLASS,payload).then((res)=>{
        if (!res.error) {
          this.classrooms = res.data ?? []
        }
      });
    },
    callApi() {
      this.loading = true
      const payload = {
        page: this.page,
        id: this.query.taskId,
        user_info: this.query.processing,
        type: this.query.typeTask,
        status: this.query.status,
        date_created: this.query.createdAt,
        course_id: this.query.course,
        classroom_id: this.query.classroom,
        admin_profile_id: this.query.personInCharge,
        exam_type: this.query.examType,
        grading_type: this.query.gradingType,
        grading_category: this.query.gradingCategory,
        deadline: this.query.deadline,
      }
      this.$store.dispatch(GET_MANAGE_TASK_LIST, payload).then(res => {
        if (!res.error) {
          this.page = res.pagination.current_page
          this.lastPage = res.pagination.last_page
          this.total = res.pagination.total
          this.manageTaskList = res.data.map(item => {
            return new TaskModel(item)
          }) ?? []
          this.taskSelectedList = []
          this.isSelectedAll = false
        }
      }).catch(e => {
        console.log(e, 'error')
      }).finally(() => {
        this.loading = false
      })
    },
    async handleSearch() {
      this.page = 1
      await this.pushParams().catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
      this.getManageTaskList()
    },
    async pushParams() {
      await this.$router.replace({
        name: 'ManageTaskList',
        query: {
          id: this.query.taskId,
          type: this.query.typeTask,
          handler: this.query.processing,
          status: this.query.status,
          course_id: this.query.course,
          classroom_id: this.query.classroom,
          created_at: this.query.createdAt,
          admin_id: this.query.personInCharge,
          exam_type: this.query.examType,
          grading_type: this.query.gradingType,
          grading_category: this.query.gradingCategory,
          deadline: this.query.deadline
        }
      })
      return null
    },
    getTaskSelectedList() {
      this.taskSelectedList = this.manageTaskList.filter(item => item.selected)
    },
    getManageTaskList() {
      this.getParams()
      this.callApi()
    },
    getQueryValue(value) {
      if (value === undefined || value === null || value === '') {
        return null
      }
      return isNaN(+value) ? value : +value
    },
    getParams() {
      const query = this.$route.query
      this.query.taskId = query.id
      this.query.typeTask = query.type ? +query.type : null
      this.query.processing = query.handler
      this.query.status = query.status ? JSON.parse(`[${query.status}]`) : []
      this.query.course = query.course_id ? JSON.parse(`[${query.course_id}]`) : []
      this.query.classroom = query.classroom_id ? JSON.parse(`[${query.classroom_id}]`) : []
      this.query.personInCharge = query.admin_id
      this.query.createdAt = query.created_at
      this.query.examType = this.getQueryValue(query.exam_type)
      this.query.gradingType = query.grading_type
      this.query.gradingCategory = this.getQueryValue(query.grading_category)
      this.query.deadline = query.deadline
    },

    exportExcelAiWriting() {
      this.loading_export = true;
      this.$store.dispatch(EXPORT_EXCEL_AI_WRITING, {date_range: this.query.createdAt}).then(res => {
        if (!res.error) {

        }
      }).catch(e => {
        console.log(e, 'error')
      }).finally(() => {
        this.loading_export = false
      })
    }

    },
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bg-blue-500 {
  background: #0066FF;
  color: white;
}

.bg-success {
  background: #1BC5BD;
  color: white;
}

.bg-red-500 {
  background: #C40D0D;
  color: white;
}

.bg-yellow-500 {
  background: #FF9900;
  color: black;
}

.bg-orange-500 {
  background: #E8710A;
  color: white;
}

.mx-datepicker-popup {
  z-index: 9999999 !important;
}

.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
  .grid-filter {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px 30px;
  }
}

.bg-entrance-exam-speaking {
  background: #0978CD;
  color: white;
}

.bg-entrance-exam-general {
  background: #FF9393;
  color: white;
}
</style>
